import {
  Component,
  Input,
  Output,
  OnInit,
  OnDestroy,
  OnChanges,
  SimpleChanges,
  EventEmitter,
  AfterViewInit
} from '@angular/core';
import { AppState } from '@eview/core/store/states/app.state';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import {
  FormAttributes,
  FormAttribute,
  FormAttributeType,
  FormAttributeInput
} from '@eview/core/domain/form/form-attribute';
import { ListFormAttributes } from '@eview/core/store/actions/form-attributes.actions';
import { PostHelpers } from '@eview/core/domain/post/post.helpers';
import { FilterHelpers } from '@eview/core/domain/filters/filters.helper';
import {
  FilterItem,
  PostFilters
} from '@eview/core/domain/post/post';
import { User, ListUserOptions } from '@eview/core/models/user';
import { UserService } from '@eview/core/users/user.service';
import { map, take } from 'rxjs/operators';
import { selectTags } from '@eview/core/store/selectors/tags.selector';
import { selectMap } from '@eview/core/store/selectors/map.selector';
import { selectFormAttributes,
  selectFormAttributesLoadedFormId
} from '@eview/core/store/selectors/form-attributes.selector';
import { selectForms } from '@eview/core/store/selectors/forms.selector';
import { FormStatusScheme } from '@eview/core/domain/form/form';
import { Tag, Tags } from '@eview/core/domain/tags/tag';
import { TagHelpers } from '@eview/core/domain/tags/tag.helpers';
import {
  ETagSelectorActions,
  TagSelectorChange,
  TagSelectorSetById
} from '../post-editor/tag-selector/tag-selector.component';
import { FilterService } from './filters.service';
import { isEmpty, indexOf } from 'lodash';
import { OrderSort } from '@eview/core/models/commons';
import { SearchableSelectOption } from '@eview/features/ui/searchable-select/searchable-select.component';
import {
  debounceTime,
  filter,
  tap,
  switchMap,
  catchError
} from 'rxjs/operators';
import { combineLatest, Observable, Subscription, of } from 'rxjs';
import { NgbDate, NgbCalendar, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { cloneDeep } from 'lodash';
import { selectUser } from '@eview/core/store/selectors/user.selector';
import { CatalogFacade } from '@eview/core/store/facades/catalog.facade';

const PAGE_SIZE = 20;
const RISK_FORM_ID = 2;
@Component({
  selector: 'eview-filters',
  templateUrl: 'filters.component.html',
  styleUrls: ['filters.component.scss']
})
export class FiltersComponent implements OnInit, OnDestroy, OnChanges, AfterViewInit {
  @Input() isClear: boolean;
  @Input() formID: number;
  @Output() onApply: EventEmitter<Object> = new EventEmitter();
  @Output() onCancel: EventEmitter<Boolean> = new EventEmitter();

  viewOnlyMode$: Observable<any>;
  tags$: Observable<Tags>;
  availableTags$: Observable<Tag[]>;

  subs: Subscription;
  model: string;

  applyDisabled: boolean = true;
  selectedTags: any = [];
  formAttributesFilters: FormAttribute[] = [];
  PostHelpers = PostHelpers;
  selectedPostFilters: Record<string, any> = {};
  selectedFormFilters: Record<string, any> = {};
  listOption: ListUserOptions;
  FilterHelpers = FilterHelpers;
  formTagsfilters: any = [];
  /** Toggled to remount tag selectors on clear. */
  showTagSelectors = true;
  users: User[];
  limit: number = PAGE_SIZE;
  public searchFailed: boolean = false;
  public isSearchingByAddress: boolean = false;
  public total_count: number = 0;
  public formatter = (result: any) => result.realname;

  hoveredDate: NgbDate | null = null;

  fromDate: NgbDate | null;
  toDate: NgbDate | null;
  minDate: NgbDate | null;
  maxDate: NgbDate = (() => {
    const n = new Date();
    return new NgbDate(n.getFullYear(), n.getMonth() + 1, n.getDate());
  })();

  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.onDateSelectionStart(date);
      return;
    }
    if (this.fromDate && !this.toDate && (date.equals(this.fromDate) || date.after(this.fromDate))) {
      this.onDateSelectionEnd(date);
      return;
    }
    this.toDate = null;
    this.onDateSelectionStart(date);
  }

  onDateSelectionStart(date: NgbDate) {
    if (date) {
      this.fromDate = date;
      this.minDate = this.fromDate;
      if (this.toDate && this.toDate.before(date)) {
        this.toDate = null;
      }
      this.restoreApplyButtonState();
    }
  }

  onDateSelectionEnd(date: NgbDate) {
    if (date) {
      this.toDate = date;
      this.restoreApplyButtonState();
    }
  }

  /** Typed date input — empty clears the filter and updates Aplicar. */
  onFromDateTyped(raw: string): void {
    this.fromDate = this.parseDateInput(raw, this.fromDate);
    this.minDate = this.fromDate;
    if (this.fromDate && this.toDate && this.toDate.before(this.fromDate)) {
      this.toDate = null;
    }
    if (!this.fromDate) {
      this.minDate = null;
    }
    this.restoreApplyButtonState();
  }

  onToDateTyped(raw: string): void {
    this.toDate = this.parseDateInput(raw, this.toDate);
    this.restoreApplyButtonState();
  }

  isHovered(date: NgbDate) {
    return this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate);
  }

  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return date.equals(this.fromDate) || (this.toDate && date.equals(this.toDate)) || this.isInside(date) || this.isHovered(date);
  }

  /**
   * Empty → null (cleared). Valid date → parsed. Partial/invalid → keep previous.
   */
  parseDateInput(input: string, previous: NgbDate | null): NgbDate | null {
    if (input == null || String(input).trim() === '') {
      return null;
    }
    const parsed = this.formatterDate.parse(String(input).trim());
    if (parsed && this.calendar.isValid(NgbDate.from(parsed))) {
      return NgbDate.from(parsed);
    }
    return previous;
  }

  /** @deprecated Prefer parseDateInput */
  validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
    return this.parseDateInput(input, currentValue);
  }

  constructor(private store: Store<AppState>,
    private actions$: Actions,
    private filterService: FilterService,
    private userService: UserService,
    private calendar: NgbCalendar,
    public formatterDate: NgbDateParserFormatter,
    private catalog: CatalogFacade
  ) {
    this.subs = new Subscription();
    this.viewOnlyMode$ = this.store
      .select(selectUser)
      .pipe(map(users => (users ? true : false)));
    this.tags$ = this.store.select(selectTags);
    this.availableTags$ = this.tags$.pipe(
      map(tags => tags.results as Tag[])
    );
  }

  formAttributes: FormAttributes;

  mapRegions: any = [];

  filters: FilterItem[] = [];

  PostFilters = PostFilters;

  selectedRegion: any = [];

  nestedTags$ = (inputType) => {
    let type = inputType.input;
    if (type === FormAttributeType.Tags) {
      // Primero intentar usar options.type si existe
      if (inputType.options && inputType.options.type) {
        type = inputType.options.type;
      } else {
        // Si no existe, convertir el label a formato con guiones (manteniendo tildes)
        type = inputType.label
          .toLowerCase()
          .replaceAll(' ', '-');
      }
    }
    
    return this.tags$.pipe(
      map(tags => {
        if (tags && tags.results) {
          const processed = TagHelpers.ProcessForRendering(tags, { input: type, value: [this.selectedTags[type]] });
          return processed;
        }
        return null;
      })
    );
  }

  ngAfterViewInit() {
    this.syncTagSelectorsFromSelection();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isClear']?.currentValue === true) {
      this.resetFilterValues(false);
    }
    if (
      changes['isClear'] &&
      changes['isClear'].currentValue === false &&
      !changes['isClear'].firstChange
    ) {
      this.applyPrefetchForForm();
      this.restoreApplyButtonState();
    }
    if (changes['formID'] && !changes['formID'].firstChange) {
      this.reinitializeForForm();
    }
    if (
      changes['formID'] &&
      changes['formID'].currentValue !== changes['formID'].previousValue
    ) {
      this.clearFormSpecificFilterFields();
    }
  }

  ngOnInit() {
    this.catalog.ensureTags();
    if (this.isClear) {
      this.resetFilterValues(false);
    } else {
      this.applyPrefetchForForm();
    }
    this.requestFormAttributes();
    this.setupFormAttributesSubscription();
    this.setupMapFiltersSubscription();
    this.setupTagSelectorSubscription();
  }

  private reinitializeForForm(): void {
    this.clearFormSpecificFilterFields();
    this.resetFilterValues(false);
    if (!this.isClear) {
      this.applyPrefetchForForm();
    }
    this.requestFormAttributes();
  }

  private requestFormAttributes(): void {
    if (!this.formID) {
      return;
    }
    this.store.dispatch(new ListFormAttributes({ id: this.formID }));
  }

  /** Clears tag/select fields while keeping base post filters (status, region, dates). */
  private clearFormSpecificFilterFields(): void {
    this.formTagsfilters = [];
    this.formAttributesFilters = [];
    this.selectedFormFilters = {};
    this.selectedTags = {};
    this.rebuildFiltersList();
  }

  private setupFormAttributesSubscription(): void {
    this.subs.add(
      combineLatest([
        this.store.select(selectFormAttributes),
        this.store.select(selectFormAttributesLoadedFormId)
      ]).subscribe(([formAttributes, loadedFormId]) => {
        if (!this.formID) {
          return;
        }
        if (loadedFormId === null) {
          return;
        }
        if (loadedFormId !== this.formID) {
          this.clearFormSpecificFilterFields();
          return;
        }
        if (formAttributes?.results?.length) {
          this.processFormAttributes(formAttributes);
        } else {
          this.clearFormSpecificFilterFields();
        }
      })
    );
  }

  private syncTagSelectorsFromSelection(): void {
    if (!this.selectedTags || typeof this.selectedTags !== 'object') {
      return;
    }
    setTimeout(() => {
      Object.keys(this.selectedTags).forEach(key => {
        const id = this.selectedTags[key];
        if (id !== undefined && id !== null) {
          this.store.dispatch(new TagSelectorSetById(id));
        }
      });
    });
  }

  /**
   * Enable Aplicar only when at least one real criterion is selected.
   * Empty/cleared UI must keep Aplicar disabled — use "Borrar todo" to reset applied filters.
   */
  private restoreApplyButtonState(): void {
    const isEmptySelect = (v: unknown): boolean =>
      v === undefined ||
      v === null ||
      String(v).trim() === '' ||
      String(v) === '-1' ||
      String(v) === '0';

    const hasPostFilter = Object.values(this.selectedPostFilters ?? {}).some(
      v => !isEmptySelect(v)
    );
    const hasFormFilter = Object.values(this.selectedFormFilters ?? {}).some(
      v => !isEmptySelect(v)
    );
    const hasTags = Object.values(this.selectedTags ?? {}).some(
      v => v !== undefined && v !== null && String(v).trim() !== ''
    );
    const hasUser = Array.isArray(this.users) && this.users.length > 0;
    this.applyDisabled = !(
      hasPostFilter ||
      hasFormFilter ||
      hasTags ||
      hasUser ||
      !!this.fromDate ||
      !!this.toDate
    );
  }

  private setupMapFiltersSubscription(): void {
    this.subs.add(
      this.store.select(selectMap).subscribe(map => {
        this.mapRegions = map?.regions ?? [];
        this.rebuildFiltersList();
      })
    );
  }

  private processFormAttributes(formAttributes: FormAttributes): void {
    if (!formAttributes?.results?.length || !this.formID) {
      return;
    }

    this.formAttributes = formAttributes;
    const stored = this.filterService.getForForm(this.formID);
    const storedForm = stored?.formFilters ?? {};
    const mgmtLev3 = this.mapRegions?.length
      ? FilterHelpers.GetFilters(
          this.mapRegions,
          this.formID,
          this.resolveStatusScheme()
        ).find(
          el => el.label === 'FILTER_LABEL_MGMT_LEV_3'
        )
      : undefined;

    const tagsAttributes = this.formAttributes.results.filter(
      item => item.type === FormAttributeType.Tags
    );
    this.formTagsfilters = tagsAttributes.filter(
      (item, index, self) =>
        index === self.findIndex(t => t.key === item.key)
    );

    const labelsEnTags = this.formTagsfilters.map(t => t.label);

    let formAttrsFiltered = this.formAttributes.results.filter(
      item =>
        item.type === FormAttributeType.Varchar &&
        (item.input === FormAttributeInput.Radio ||
          item.input === FormAttributeInput.Select ||
          item.input === FormAttributeInput.Checkbox)
    );
    formAttrsFiltered = formAttrsFiltered.filter(
      item => !labelsEnTags.includes(item.label)
    );
    // Legacy: hide duplicate Conflictividad Subcategoría selects if still present.
    // After tags migration they appear once via formTagsfilters.
    formAttrsFiltered = formAttrsFiltered.filter(
      item =>
        item.label !== 'Conflictividad Subcategoría' &&
        item.label !== 'Operaciones Subcategoría'
    );

    const textFilters = this.formAttributes.results.filter(
      item =>
        item.type === FormAttributeType.Varchar &&
        item.input === FormAttributeInput.Text &&
        !labelsEnTags.includes(item.label)
    );

    this.formAttributesFilters = [
      ...formAttrsFiltered.filter(
        (item, index, self) =>
          index === self.findIndex(t => t.label === item.label)
      ),
      ...textFilters.filter(
        (item, index, self) =>
          index === self.findIndex(t => t.label === item.label)
      )
    ];

    const nextFormFilters: Record<string, any> = {};
    this.formAttributesFilters.forEach(item => {
      const saved = storedForm[item.key];
      nextFormFilters[item.key] =
        saved !== undefined && saved !== null
          ? saved
          : item.input === FormAttributeInput.Text
            ? ''
            : -1;
      this.hydrateFormFilterOptions(item, mgmtLev3);
    });
    this.selectedFormFilters = nextFormFilters;

    if (!this.isClear && stored?.tags) {
      this.selectedTags = { ...stored.tags };
    } else if (this.isClear) {
      this.selectedTags = {};
    }

    this.rebuildFiltersList();
    this.restoreApplyButtonState();
    this.syncTagSelectorsFromSelection();
  }

  private hydrateFormFilterOptions(
    item: FormAttribute,
    mgmtLev3?: FilterItem
  ): void {
    if (item.input === FormAttributeInput.Text) {
      return;
    }
    if (item.label === 'Province' && mgmtLev3?.values?.length) {
      item.options = mgmtLev3.values.map(
        (element: { name: string }) => element.name
      );
      return;
    }
    if (!item.options?.length) {
      return;
    }
    const first = item.options[0];
    if (typeof first !== 'string' && first !== null && typeof first === 'object') {
      item.options = item.options.map((o: { label?: string; name?: string }) =>
        o?.label ?? o?.name ?? String(o)
      );
    }
  }

  private resolveStatusScheme(): string {
    // No form selected / unknown: show union of both schemes.
    if (!this.formID) {
      return 'all';
    }
    let scheme: string = FormStatusScheme.Default;
    this.store
      .select(selectForms)
      .pipe(take(1))
      .subscribe(forms => {
        const match = forms?.results?.find(f => Number(f.id) === Number(this.formID));
        scheme = PostHelpers.NormalizeStatusScheme(match?.status_scheme);
      });
    return scheme;
  }

  private rebuildFiltersList(): void {
    let baseFilters: FilterItem[] = [];
    const statusScheme = this.resolveStatusScheme();
    if (this.mapRegions?.length) {
      baseFilters = FilterHelpers.GetFilters(
        this.mapRegions,
        this.formID,
        statusScheme
      );
    }

    const tagFilters = FilterHelpers.GetTagsFilters(this.formTagsfilters ?? []);

    let combined = [...baseFilters, ...tagFilters];
    combined = combined.filter(
      item => !(this.formID === RISK_FORM_ID && item.queryParam === 'tags')
    );

    const storedPost = this.filterService.getForForm(this.formID)?.postFilters ?? {};
    const nextPostFilters: Record<string, any> = {};
    combined.forEach(item => {
      const qp = item.queryParam;
      nextPostFilters[qp] =
        this.selectedPostFilters[qp] !== undefined
          ? this.selectedPostFilters[qp]
          : storedPost[qp] !== undefined
            ? storedPost[qp]
            : -1;
    });
    this.selectedPostFilters = nextPostFilters;

    this.filters = combined;

    this.viewOnlyMode$.pipe(take(1)).subscribe(boolean => {
      this.filters.forEach(item => {
        if (boolean) {
          item['isDisabled'] = false;
        } else if (
          item.queryParam === PostFilters.Incident_Status ||
          item.queryParam === PostFilters.Priority
        ) {
          item['isDisabled'] = true;
        } else {
          item['isDisabled'] = false;
        }
      });
    });
  }

  private applyPrefetchForForm(): void {
    const prefetchFilters = this.filterService.getForForm(this.formID);
    if (!isEmpty(prefetchFilters)) {
      this.selectedPostFilters = {
        ...(prefetchFilters.postFilters ?? {})
      };
      this.selectedFormFilters = {
        ...(prefetchFilters.formFilters ?? {})
      };
      if (prefetchFilters.tags) {
        this.selectedTags = { ...prefetchFilters.tags };
      }
      if (this.selectedPostFilters[PostFilters.Department]) {
        this.onChange(PostFilters.Department);
      }
      if (prefetchFilters.fromDate) {
        this.fromDate = prefetchFilters.fromDate as NgbDate;
        this.minDate = this.fromDate;
      }
      if (prefetchFilters.toDate) {
        this.toDate = prefetchFilters.toDate as NgbDate;
      }
      this.restoreApplyButtonState();
    }
  }

  private setupTagSelectorSubscription(): void {
    this.subs.add(
      this.actions$
        .pipe(ofType<TagSelectorChange>(ETagSelectorActions.Change))
        .subscribe(action => {
          if (action.payload) {
            if (action.payload.id === undefined || action.payload.id === null) {
              delete this.selectedTags[action.payload.type];
            } else {
              this.selectedTags[action.payload.type] = action.payload.id;
            }
            this.formAttributesFilters.map((item) => {
              // Validar que config existe y tiene elementos antes de acceder
              if(item.config && item.config[0] && item.config[0].target && item.config[0].target.value == action.payload.id) {
                this.selectedFormFilters[item.key] =  this.selectedFormFilters[item.key]  == 0  ? -1 : this.selectedFormFilters[item.key];
              }else if(item.config && item.config[0]) {
                this.selectedFormFilters[item.key] =  0;
              }
           });
            this.restoreApplyButtonState();
          }
        })
    );
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
    this.selectedTags = {};
  }

  setFilterValues(keyToBeSet: string, values: any[]) {
    this.filters.map((item) => {
      if (item.queryParam === keyToBeSet) {
        item.values = values;
      }
      return item;
    });

    if (this.formAttributesFilters) {
      this.formAttributesFilters.map((item) => {
        let temp = [];
        values.map((item) => {
          temp.push(item.value);
        });
        if (item.key === keyToBeSet) {
          item['options'] = cloneDeep(temp);
        }
        return item;
      });
    }
  }

  isFiltersSelected() {
    this.restoreApplyButtonState();
  }

  onChange(optionSelected: string) {
    if (optionSelected === PostFilters.Department || optionSelected === 'region_default') {
      this.selectedRegion = (optionSelected === 'region_default') ? this.selectedFormFilters['region_default'] : this.selectedPostFilters[PostFilters.Department];
      optionSelected = (optionSelected === PostFilters.Department) ? PostFilters.Province : 'zone_default';
     let optionSelectedDep = (optionSelected === PostFilters.Province) ? PostFilters.District : 'zone_default';
      if (this.selectedRegion != '-1' && this.selectedRegion != null && this.mapRegions?.[this.selectedRegion]) {
        let temp = [], districts = [], provinces = [] , temp1 = [];
        this.mapRegions[this.selectedRegion].forEach(element => {
          if (indexOf(temp, element.district) === -1) {
            const existingDistrict= districts.find(district => district.name === element.district);
              if(!existingDistrict){
               temp1.push(element.district);
              districts.push({ name: element.district, value: element.district });
            }
          }
          if (indexOf(temp1, element.province) === -1) {
            const existingProvince = provinces.find(province => province.name === element.province);

            if (!existingProvince) {
              temp.push(element.department);
                    // Push the province to the provinces array only if it doesn't already exist
                provinces.push({ name: element.province, value: element.province });
           }
          }
        });
        this.setFilterValues(optionSelected, provinces);
        this.setFilterValues(optionSelectedDep, districts);
      } else {
        // Cleared department/region → reset dependent geography filters
        if (this.selectedPostFilters) {
          if (PostFilters.Province in this.selectedPostFilters) {
            this.selectedPostFilters[PostFilters.Province] = -1;
          }
          if (PostFilters.District in this.selectedPostFilters) {
            this.selectedPostFilters[PostFilters.District] = -1;
          }
        }
        this.setFilterValues(optionSelected, []);
        this.setFilterValues(optionSelectedDep, []);
      }
    }
    this.restoreApplyButtonState();
  }

  onApplyClick() {
    const collection: Record<string, any> = {};
    const existing = this.filterService.getForForm(this.formID);
    this.filterService.setForForm(this.formID, {
      postFilters: this.selectedPostFilters,
      formFilters: this.selectedFormFilters,
      tags: this.selectedTags,
      fromDate: this.fromDate,
      toDate: this.toDate,
      searchQuery: existing?.searchQuery
    });
    if (this.selectedPostFilters) {
      for (const key in this.selectedPostFilters) {
        let val = this.selectedPostFilters[key].toString();
        if (val !== '-1')
          collection[key] = this.selectedPostFilters[key];
      }
    }
    if (this.selectedFormFilters) {
      for (const key in this.selectedFormFilters) {
        let val = this.selectedFormFilters[key];
        if (val && val !== '-1' && val !== '0' && val.toString().trim() !== '')
          collection['values[' + key + ']'] = this.selectedFormFilters[key];
      }
    }
    if (this.selectedTags && Object.keys(this.selectedTags).length > 0) {
      const tagsValues = Object.values(this.selectedTags).filter(item => item !== undefined);
      if (tagsValues.length > 0) {
        collection['tags'] = Object.values(tagsValues);
      }
    }
    if (this.users && this.users.length > 0) {
      collection['user'] = this.users[0].id;
    }
    if (collection[PostFilters.Incident_Status]) {
      collection['status'] = collection[PostFilters.Incident_Status];
      delete collection[PostFilters.Incident_Status];
    }
    if (this.fromDate) {
      collection['created_after'] = FilterHelpers.GetDateFromObject(this.fromDate);
    }
    if (this.toDate) {
      collection['created_before'] = FilterHelpers.GetDateFromObject(this.toDate);
    }
    this.onApply.emit(collection);
    this.applyDisabled = true;
  }

  onValueSelected(result) {
    const selectedUser = result && result.item ? result.item : [];
    this.users = this.users.filter(user => (user.realname === selectedUser.realname));
    this.restoreApplyButtonState();
  }

  onUserSearchModelChange(value: unknown): void {
    if (value == null || value === '' || (typeof value === 'string' && !value.trim())) {
      this.model = null;
      this.users = null;
    }
    this.restoreApplyButtonState();
  }

  resetFilterValues(clearStored = false): void {
    if (this.filters?.length) {
      this.filters.forEach(item => {
        if (item.type !== 'tags') {
          this.selectedPostFilters[item.queryParam] = -1;
        }
      });
    }

    if (this.formAttributesFilters?.length) {
      this.formAttributesFilters.forEach(item => {
        this.selectedFormFilters[item.key] =
          item.input === FormAttributeInput.Text ? '' : -1;
      });
    } else {
      this.selectedFormFilters = {};
    }

    this.selectedTags = {};
    this.remountTagSelectors();
    this.fromDate = null;
    this.toDate = null;
    this.minDate = null;
    this.hoveredDate = null;
    this.model = null;
    this.users = null;
    this.selectedRegion = [];

    if (clearStored && this.formID) {
      this.filterService.clearForForm(this.formID);
    }

    this.applyDisabled = true;
  }

  private remountTagSelectors(): void {
    this.showTagSelectors = false;
    setTimeout(() => {
      this.showTagSelectors = true;
    });
  }

  onCancelClick(): void {
    this.resetFilterValues(true);
    this.onCancel.emit(false);
  }

  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      tap(() => {
        this.searchFailed = false;
        this.isSearchingByAddress = true;
      }),
      filter(term => {
        if (term.length >= 2) {
          return true;
        } else {
          this.isSearchingByAddress = false;
          return this.isSearchingByAddress;
        }
      }),
      switchMap(address => {
        this.listOption = {
          offset: 0,
          limit: this.limit,
          orderby: 'realname',
          order: OrderSort.Asc,
          q: address
        };

        return this.userService.list(this.listOption).pipe(
          map(data => {
            if (data) {
              this.searchFailed = false;
              this.total_count = data.total_count;
              return data.results.map(res => res);
            } else {
              this.searchFailed = address === '' ? false : true;
              return [];
            }
          }),
          catchError(err => {
            this.searchFailed = true;
            this.isSearchingByAddress = false;
            return of(null);
          })
        )
      }),
      tap((data) => {
        this.users = data;
        this.isSearchingByAddress = false;
        return this.isSearchingByAddress;
      })
    );

  postFilterSelectOptions(filter: FilterItem): SearchableSelectOption[] {
    return (filter.values || []).map(option => ({
      value: option.value,
      label: option.name
    }));
  }

  formFilterSelectOptions(formFilter: FormAttribute): SearchableSelectOption[] {
    return (formFilter.options || []).map(option => ({
      value: option,
      label: option
    }));
  }
}
